import * as R from 'ramda'
import schema from 'shared/db/schema.json'
import request from 'src/lib/data/request'
import * as bannerActions from 'src/store/action-methods/banner'

const errorTextMap = {
  ':db.error/unique-conflict': 'must be unique',
  ':db.error/not-an-entity': 'is not an entity',
  ':db.error/missing-cap': 'missing required capability',
  ':db.error/tempid-not-an-entity': 'temp id not an entity',
  ':db.error/nil-value': 'transaction invalid: contains nil value',
  'invalid-csrf-token': 'invalid csrf token',
  'illegal-transaction': 'illegal transaction',
  'illegal-excise-operation': 'illegal excise operation',
  'coupon-code-not-found': 'invalid coupon code',
  'coupon-code-already-redeemed': 'coupon code has already been claimed'
}

function errorBodyMessage(body) {
  if (!body) {
    return 'something went wrong'
  }

  const errorText = errorTextMap[body.error]

  if (errorText) {
    const name = R.path(['info', 'invalid-attr', 'name'], body)
    const namespace = R.path(['info', 'invalid-attr', 'namespace'], body)
    const schemaObject = R.find(R.whereEq({ namespace, ident: name }))(schema)

    if (!schemaObject) {
      return `${errorText}`
    }

    return `${schemaObject.doc} ${errorText}`
  }

  if (body[':yd-anom/category']) {
    return body[':yd-anom/message']
  }

  return body.cause || body.error
}

async function errorTextCheck(body) {
  const { reduxStore } = await import('src/store')
  if (!reduxStore) throw new Error('Store not found')

  const msg = errorBodyMessage(body)

  if (msg) {
    reduxStore.dispatch(
      bannerActions.setBanner({
        msg,
        open: true,
        type: 'error',
        assertive: true
      })
    )
  } else {
    throw new Error(msg)
  }
}

export function transactErrMsg(e) {
  if (e.response) {
    return errorBodyMessage(e.response.body)
  }

  return R.is(String, e) ? e : R.toString(e)
}

export default (async function transact(data, opts = {}) {
  const { alwaysThrow = false } = opts

  try {
    const res = await request().post('/transact').send(data)

    return res.body
  } catch (e) {
    if (alwaysThrow) {
      throw e
    }

    const body = R.path(['response', 'body'], e)

    if (body) {
      errorTextCheck(body)
    }
  }
})
